export default "__VITE_ASSET__CFca0oqT__"